import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const HelpButton = ({
  type,
  theme,
  showContent,
  content,
  onHelpClick = () => {},
}) => {
  return (
    <div>
      <button
        className={classNames(
          'c-kd-select-geography__help-button',
          theme['c-kd-select-geography__help-button'],
        )}
        onClick={() => onHelpClick()}
        title={type}
      />
      {showContent && content}
    </div>
  );
};

HelpButton.propTypes = {
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  type: PropTypes.string.isRequired,
  onHelpClick: PropTypes.func,
  showContent: PropTypes.bool,
};

export default HelpButton;



// WEBPACK FOOTER //
// ./app/components/KdSelectGeography/HelpButton.js